import { render, staticRenderFns } from "./Tasks.yaml?vue&type=template&id=76b983bc&component"
import script from "./Tasks.yaml?vue&type=script&lang=ts&component"
export * from "./Tasks.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports